import { FormattedMessage } from 'react-intl';
import { CollectionPointWithI18nKey } from '../../../../types/collectionPoints';
import { getAssetUrl } from '../../../../utils/config';
import LoadingIndicator from '../../../atoms/LoadingIndicator';
import { ViewOption } from '../SearchPage/ViewOptions';
import Details from './Details';
import Map from './Map';

const BackButton = ({ view, onClick }: { view: ViewOption; onClick: () => void }) => (
  <div className="collection-point-detail-page__back-button" onClick={onClick}>
    <img src={getAssetUrl('collectionPoints/chevronLeft.svg')} alt="left" />
    <p>
      <FormattedMessage
        id="shipping.collectionPoint.back"
        values={{ view: <FormattedMessage id={`shipping.collectionPoint.views.${view}`} /> }}
      />
    </p>
  </div>
);

type DetailPageProps = {
  location: CollectionPointWithI18nKey;
  view: ViewOption;
  onBackButtonClick: () => void;
  isGoogleMapsSdkLoaded: boolean;
};

const DetailPage = ({ location, view, onBackButtonClick, isGoogleMapsSdkLoaded }: DetailPageProps) => (
  <>
    <BackButton view={view} onClick={onBackButtonClick} />
    <Details location={location} />
    {isGoogleMapsSdkLoaded ? (
      <Map location={location} />
    ) : (
      <div className="location-detail-map">
        <LoadingIndicator />
      </div>
    )}
  </>
);

export default DetailPage;
